import { render, staticRenderFns } from "./StopPL.vue?vue&type=template&id=3527d14f"
import script from "./StopPL.vue?vue&type=script&lang=js"
export * from "./StopPL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports